import React from 'react';
import './App.scss';
import Routes from './home/components/routes/routes';
import SharedThemeCategory from './shared-storage/category-theme'
import CommonApi from './home/apis/common';
import { getStaticText } from '../src/home/utility/static-text-modal';
import SharedStaticText from '../src/shared-storage/static-text-store';
import SessionCache from './home/components/routes/session-cache';
import CommonUtils from './home/utility/common-utilities';

class App extends React.Component {


  constructor(props) {
    super(props);
    this.getConfigurations();
    this.state = {
      isListening: false,
      isOnline: navigator.onLine
    };

    // this.updateOnlineStatus = this.updateOnlineStatus.bind(this);
    // this.updateOnlineStatus()
  }


  componentDidMount() {
    this.setSharedThemeCategory()
    console.log(this.state.isOnline)
    // if (window.electron) {
    //   console.log('inside electron,')
    //   window.electron.ipcRenderer.once('ipc-example', (arg) => {
    //     // eslint-disable-next-line no-console
    //     console.log(arg);
    //   });
    //   window.electron.ipcRenderer.send('ipc-example', ['ping']);
    // }

    // this.handleStartListening()



    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);

    if (window.electron) {
      this.resetZoom()
    }
  }

  resetZoom() {
    window.electron.ipcRenderer.send('reset-zoom', ['ping'])
  }


  updateOnlineStatus() {
    // Update the state with the current online status
    // console.log(navigator.onLine)
    // this.setState({ isOnline: navigator.onLine }, () => {
    // });
  }

  // handleStartListening = () => {
  //   const { isListening } = this.state;

  //   if (isListening) {
  //     this.setState({ isListening: false });
  //     window.electron.remoteControl.unsubscribeEvents();
  //     window.electron.remoteControl.close();
  //   } else {
  //     this.setState({ isListening: true });
  //     console.log('Opening remote control', window.electron.remoteControl.open);
  //     window.electron.remoteControl.open();

  //     window.electron.remoteControl.subscribeEvents((data) => {
  //       console.log('Received data:', data);
  //     });
  //   }
  //   // window.electron.ipcRenderer.once('ipc-example', (arg) => {
  //   //   // eslint-disable-next-line no-console
  //   //   console.log(arg);
  //   // });
  //   // window.electron.ipcRenderer.send('ipc-example', ['ping']);
  // };

  // componentWillUnmount() {
  //   // Cleanup on component unmount
  //   window.electron.remoteControl.unsubscribeEvents();
  //   window.electron.remoteControl.close();
  // }

  componentWillUnmount() {
    // Remove event listeners when the component unmounts
    // window.removeEventListener('online', this.updateOnlineStatus);
    // window.removeEventListener('offline', this.updateOnlineStatus);
  }


  setSharedThemeCategory() {


    if (!this.state.isOnline) {
      let data = {
        response: [
          {
            "_id": "6451fc67d02813cd036c2775",
            "categoryThemeId": "1",
            "title": "Number system",
            "themeColor": "#6B52C8",
            "learningContentBackground": "#6B52C81A",
            "secondaryColors": {
              "assessmentOptionsBorder": "#6B52C8",
              "groupingDropBoxHeader": "#E8E3FA",
              "dragItemBorder": "#DCDCFF",
              "chapterCardColor": "#E8E2FF"
            },
            "linearGradient": {
              "groupingMatchingQuestionDragBox": [
                "#FFFFFF",
                "#DCDCFF"
              ],
              "binaryCard": [
                "#6B52C833",
                "#FFFFFF"
              ],
              "checkPointNotes": [
                "#FFFFFF",
                "#D1C9ED"
              ],
              "steps": [
                "#E9E7FF",
                "#FFFFFF"
              ],
              "formulaCard": [
                "#F5F4FF",
                "#F5F4FF"
              ],
              "feedbackCard": [
                "#FFFFFF",
                "#F9F9FF"
              ],
              "chapterProgress": [
                "#443FF6",
                "#8D8AF9",
                "#B1B0FB",
                "#D6D5FD"
              ],
              "workoutEndCard": [
                "#FAF9FF",
                "#FFFFFF"
              ]
            },
            "countingwellLastUpdateTimestamp": "2020-12-07T17:52:18.322Z"
          },
          {
            "_id": "6451fc67d02813cd036c2776",
            "categoryThemeId": "2",
            "title": "Data handing",
            "themeColor": "#6666FF",
            "learningContentBackground": "#6666FF1A",
            "secondaryColors": {
              "assessmentOptionsBorder": "#6666FF",
              "groupingDropBoxHeader": "#EDEDFF",
              "dragItemBorder": "#DCDCFF",
              "chapterCardColor": "#DDDDFF"
            },
            "linearGradient": {
              "groupingMatchingQuestionDragBox": [
                "#FFFFFF",
                "#DCDCFF"
              ],
              "binaryCard": [
                "#6666FF33",
                "#FFFFFF"
              ],
              "checkPointNotes": [
                "#FFFFFF",
                "#E9E7FF"
              ],
              "steps": [
                "#DCDCFF",
                "#FFFFFF"
              ],
              "formulaCard": [
                "#F5F4FF",
                "#F5F4FF"
              ],
              "feedbackCard": [
                "#FFFFFF",
                "#E9E7FF"
              ],
              "chapterProgress": [
                "#6666FF",
                "#6F6FFF",
                "#8787FF",
                "#DCDCFF"
              ],
              "workoutEndCard": [
                "#F0F0FF",
                "#FFFFFF"
              ]
            },
            "countingwellLastUpdateTimestamp": "2020-12-07T17:52:18.322Z"
          },
          {
            "_id": "6451fc67d02813cd036c2777",
            "categoryThemeId": "3",
            "title": "Geometry",
            "themeColor": "#FF9501",
            "learningContentBackground": "#FF95011A",
            "secondaryColors": {
              "assessmentOptionsBorder": "#FF9501",
              "groupingDropBoxHeader": "#FFF3E1",
              "dragItemBorder": "#FFE6C3",
              "chapterCardColor": "#FFE0B5"
            },
            "linearGradient": {
              "groupingMatchingQuestionDragBox": [
                "#FFFFFF",
                "#FFFBF2"
              ],
              "binaryCard": [
                "#FF950133",
                "#FFFFFF"
              ],
              "checkPointNotes": [
                "#FFFFFF",
                "#FFC677"
              ],
              "steps": [
                "#FFC677",
                "#FFFFFF"
              ],
              "formulaCard": [
                "#FFF7EB",
                "#FFF7EB"
              ],
              "feedbackCard": [
                "#FFFFFF",
                "#FFC677"
              ],
              "chapterProgress": [
                "#FF9501",
                "#FFA425",
                "#FFC26D",
                "#FFD08E",
                "#FFC677"
              ],
              "workoutEndCard": [
                "#FFE0B5",
                "#FFFFFF"
              ]
            },
            "countingwellLastUpdateTimestamp": "2020-12-07T17:52:18.321Z"
          },
          {
            "_id": "6451fc67d02813cd036c2778",
            "categoryThemeId": "4",
            "title": "Mathematics applications",
            "themeColor": "#5CC7FB",
            "learningContentBackground": "#5CC7FB1A",
            "secondaryColors": {
              "assessmentOptionsBorder": "#5CC7FB",
              "groupingDropBoxHeader": "#E1F5FF",
              "dragItemBorder": "#CFEEFE",
              "chapterCardColor": "#D6F0FF"
            },
            "linearGradient": {
              "groupingMatchingQuestionDragBox": [
                "#FFFFFF",
                "#CFEEFE"
              ],
              "binaryCard": [
                "#5CC7FB33",
                "#FFFFFF"
              ],
              "checkPointNotes": [
                "#FFFFFF",
                "#CFEEFE"
              ],
              "steps": [
                "#CFEEFE",
                "#FFFFFF"
              ],
              "formulaCard": [
                "#E7F7FF",
                "#E7F7FF"
              ],
              "feedbackCard": [
                "#FFFFFF",
                "#CFEEFE"
              ],
              "chapterProgress": [
                "#5CC7FB",
                "#7CD4FF",
                "#97DDFF",
                "#B0E5FF",
                "#CFEEFE"
              ],
              "workoutEndCard": [
                "#E9F7FF",
                "#FFFFFF"
              ]
            },
            "countingwellLastUpdateTimestamp": "2020-12-07T17:52:18.322Z"
          },
          {
            "_id": "6451fc67d02813cd036c2779",
            "categoryThemeId": "5",
            "title": "Mensuration",
            "themeColor": "#0A84FF",
            "learningContentBackground": "#0A84FF1A",
            "secondaryColors": {
              "assessmentOptionsBorder": "#0A84FF",
              "groupingDropBoxHeader": "#D9ECFF",
              "dragItemBorder": "#D9ECFF",
              "chapterCardColor": "#CDE6FF"
            },
            "linearGradient": {
              "groupingMatchingQuestionDragBox": [
                "#FFFFFF",
                "#D9ECFF"
              ],
              "binaryCard": [
                "#0A84FF33",
                "#FFFFFF"
              ],
              "checkPointNotes": [
                "#FFFFFF",
                "#80BFFF"
              ],
              "steps": [
                "#80BFFF",
                "#FFFFFF"
              ],
              "formulaCard": [
                "#DFEFFF",
                "#DFEFFF"
              ],
              "feedbackCard": [
                "#FFFFFF",
                "#80BFFF"
              ],
              "chapterProgress": [
                "#0A84FF",
                "#2B94FF",
                "#60AFFF",
                "#82C0FF",
                "#80BFFF"
              ],
              "workoutEndCard": [
                "#CDE6FF",
                "#FFFFFF"
              ]
            },
            "countingwellLastUpdateTimestamp": "2020-12-07T17:52:18.322Z"
          },
          {
            "_id": "6451fc67d02813cd036c277a",
            "categoryThemeId": "6",
            "title": "Algebra",
            "themeColor": "#FFCC00",
            "learningContentBackground": "#FFCC001A",
            "secondaryColors": {
              "assessmentOptionsBorder": "#FFCC00",
              "groupingDropBoxHeader": "#FFF5CB",
              "dragItemBorder": "#FFEB9A",
              "chapterCardColor": "#FFF4C7"
            },
            "linearGradient": {
              "groupingMatchingQuestionDragBox": [
                "#FFFFFF",
                "#FFEB9A"
              ],
              "binaryCard": [
                "#FFCC0033",
                "#FFFFFF"
              ],
              "checkPointNotes": [
                "#FFFFFF",
                "#FFE476"
              ],
              "steps": [
                "#FFE476",
                "#FFFFFF"
              ],
              "formulaCard": [
                "#FFFAE4",
                "#FFFAE4"
              ],
              "feedbackCard": [
                "#FFFFFF",
                "#FFE476"
              ],
              "chapterProgress": [
                "#FFCC00",
                "#FFD428",
                "#FFE476",
                "#FFEFAF",
                "#FFF1B6"
              ],
              "workoutEndCard": [
                "#FFF4C7",
                "#FFFFFF"
              ]
            },
            "countingwellLastUpdateTimestamp": "2020-12-07T17:52:18.322Z"
          }
        ]
      }

      let response = {};
      for (let i = 0; i < data.response.length; i++) {
        let theme = data.response[i];
        response[theme.categoryThemeId] = theme;
      }
      
      SharedThemeCategory.setThemeCategory(response)

    } else {
      CommonApi.getThemeList({ limit: 100 }).then((data) => {

        console.log(data.response)

        if (data && data.response) {
          let response = {};

          for (let i = 0; i < data.response.length; i++) {
            let theme = data.response[i];
            response[theme.categoryThemeId] = theme;
          }
          SharedThemeCategory.setThemeCategory(response)
        }
      }).catch(err => {
        //console.log(err)
      })
    }



  }

  getConfigurations = () => {

    //this.toggleLoading(true)
    let payload = {
      // configurationType: "STATIC_TEXT"
      limit: 100
    };

    CommonApi.getConfigurationsList(payload).then((data) => {
      // if (err) {
      //   this.toggleLoading(false)
      // }

      if (data && data.response && data.response.length) {

        for (let i = 0; i < data.response.length; i++) {

          let item = data.response[i]

          if (item.configurationType == 'STATIC_TEXT') {
            let contructedData = getStaticText(data.response[i].screens);
            //console.log(contructedData)
            SharedStaticText.setStaticText(contructedData);
          }

          // if (item.configurationType == 'AUTH_KEYS') {
          //   AuthKeys.setAuthKeys(item)
          // }

          // if (item && item.configurationType == 'ONBOARDING_FLOW' && item.config) {
          //   OnBoardingSharedStorage.set('config', item && item.config)
          // }
        }
      }

      // this.toggleLoading(false)
    }).catch(err => {
      //console.log(err)
      // this.toggleLoading(false)
    })
  }



  render() {
    const { isListening } = this.state;
    return (
      <>
        {<Routes></Routes>}
      </>
    );
  }

}


export default App;
